import React, {useState} from 'react'
import {Attendee} from 'Event/attendee'
import TestWebhookButton from 'organization/Event/Form/WebhookTest/TestWebhookButton'
import SelectTestAttendeeDialog from 'organization/Event/Form/WebhookTest/SelectTestAttendeeDialog'
import {useOrganization} from 'organization/OrganizationProvider'
import {api} from 'lib/url'
import {Form} from 'organization/Event/FormsProvider'
import {Answer} from 'Event/SubmissionsProvider'

export default function WebhookTest(props: {webhookURL: string; form: Form}) {
  const send = useTestWebhook()
  const {webhookURL, form} = props

  const [isVisible, setIsVisible] = useState<boolean>(false)

  const toggleVisible = () => {
    setIsVisible((current) => !current)
  }

  const onSelect = async (attendee: Attendee | null, answers: Answer[]) => {
    if (!attendee || !webhookURL) return

    return send(form, attendee, answers)
  }

  if (!webhookURL) return null

  return (
    <>
      <TestWebhookButton onClick={toggleVisible} />
      <SelectTestAttendeeDialog
        visible={isVisible}
        onClose={toggleVisible}
        onSelect={onSelect}
        form={form}
      />
    </>
  )
}

export function useTestWebhook() {
  const {client} = useOrganization()

  return async (
    form: Form,
    attendee: Attendee,
    answers: Answer[],
  ): Promise<void> => {
    const url = api(`/forms/${form.id}/test_webhook`)

    return await client.post(url, {
      attendee_id: attendee.id,
      answers,
    })
  }
}
